import {useMemo} from 'react';
import {FilterProps} from '../filter-types';
import {NetworkOptimizationStore} from './types';
import {createFilterProps} from './create-filter-props';
import {getTabFilterConfig, NetworkAnalysisTabId} from '../../../pages/network-analysis-tab-config';

export function useCountyFilter(
    noStore: NetworkOptimizationStore,
    loadingGeographyData: boolean,
    onChange: (value: string) => void,
    showRosterSelection: boolean,
    activeTab?: number
): FilterProps {
    return useMemo(() => {
        const geoFilterArgs = {
            'state_additional_info.state': noStore.appliedGeographyFilter.state,
            patient_roster_name: noStore.appliedGeographyFilter.patient_roster_name,
            standard_version: noStore.appliedGeographyFilter.standard_version,
            standard_type: noStore.appliedGeographyFilter.standard_type,
        };

        const data = noStore.getGeoFilterUniqueValuesByKey(
            'GEOGRAPHY',
            ['county_additional_info.county_name', 'ssacd'],
            geoFilterArgs,
        );

        const disabled =
            !noStore.appliedGeographyFilter.state ||
            !noStore.appliedGeographyFilter.patient_roster_name;

        // Get multi-select configuration from centralized tab config
        const tabConfig = activeTab !== undefined ? getTabFilterConfig(activeTab as NetworkAnalysisTabId) : null;
        const multiSelectConfig = !showRosterSelection && tabConfig?.county.multiSelect
            ? tabConfig.county.multiSelect
            : undefined;

        return createFilterProps(
            {
                label: 'County',
                data,
                value: noStore.appliedGeographyFilter.county,
                onChange,
                children: [
                    (item: any): string => item,
                    (item: any) => item || 'All',
                ],
                spinner: loadingGeographyData,
                disabled,
                testId: 'county-dropdown',
            },
            multiSelectConfig
        );
    }, [
        noStore.appliedGeographyFilter.county,
        noStore.appliedGeographyFilter.state,
        noStore.appliedGeographyFilter.patient_roster_name,
        noStore.appliedGeographyFilter.standard_type,
        noStore.appliedGeographyFilter.standard_version,
        loadingGeographyData,
        onChange,
        showRosterSelection,
        activeTab,
    ]);
}
